module.exports = __webpack_public_path__ + "static/media/todo-assignment.6f4bae8d.svg";